export default "__VITE_ASSET__DF3$NUZJ__"